import { Interval } from '@/api-client/models/utilization/Contracts'
export function mergeIntervals(intervals: Interval<number>[]): Interval<number>[] {
  // Sort intervals by 'from' value
  const inputIntervals = intervals
    .map(({ from, to }) => ({ from, to }))
    .sort((a, b) => (a.from || 0) - (b.from || 0))

  const mergedIntervals: Interval<number>[] = []
  let currentInterval: Interval<number> | null = null

  for (const interval of inputIntervals) {
    if (!currentInterval) {
      currentInterval = interval
    } else {
      // Check if the intervals overlap or are adjacent
      if (
        currentInterval.to === undefined ||
        interval.from === undefined ||
        currentInterval.to >= interval.from - 1
      ) {
        // Merge the intervals
        currentInterval.to =
          currentInterval.to === undefined || interval.to === undefined
            ? undefined
            : Math.max(currentInterval.to, interval.to)
      } else {
        // Add the current interval to the result and start a new one
        mergedIntervals.push(currentInterval)
        currentInterval = interval
      }
    }
  }

  // Add the last interval to the result
  if (currentInterval) {
    mergedIntervals.push(currentInterval)
  }

  if (mergedIntervals.length === 1) {
    if (mergedIntervals[0].from === undefined && mergedIntervals[0].to === undefined) {
      return []
    }
  }

  return mergedIntervals
}
